// extracted by mini-css-extract-plugin
module.exports = {"roundedModal":"roundedModal_roundedModal__3XHnZ"};